<div class="onboarding-container">
  <!-- Progress Bar -->
  <div class="pipeline">
    <div class="pipeline-track"></div>
    <div class="pipeline-progress"></div>
    @for (step of steps; track $index; let i = $index) {
      <div
        class="pipeline-node"
        [ngClass]="{
          active: currentStep === i + 1,
          completed: currentStep > i + 1,
        }"
      >
        <div class="node-indicator">0{{ i + 1 }}</div>
        <div class="node-label">{{ step.label }}</div>
      </div>
    }
  </div>

  <!-- Onboarding Card -->
  <div class="onboarding-card">
    <div class="logo-header">
      <h1 class="brand-wordmark">d<span class="ai">AI</span>rector</h1>
    </div>

    <!-- Step 1: User Details -->
    <div class="step-content" [class.active]="currentStep === 1">
      <div class="step-card-header">
        <div class="step-number">STEP 1 OF 5</div>
        <div class="card-title">Tell us about yourself</div>
        <div class="card-subtitle">Let's start by setting up your profile</div>
      </div>

      <div class="field-group">
        <label class="field-label">Profile</label>
        <div
          class="avatar-box"
          role="button"
          tabindex="0"
          (click)="fileInput.click()"
          (keydown.enter)="fileInput.click()"
          (keydown.space)="fileInput.click()"
        >
          @if (!profileImagePreviewUrl) {
            <span class="avatar-box-text">Select File</span>
          } @else {
            <img [src]="profileImagePreviewUrl" alt="Profile image" />
          }
        </div>
        <input
          #fileInput
          type="file"
          accept="image/png,image/jpeg,image/webp"
          (change)="onProfileImageSelected($event)"
          hidden
        />
      </div>

      <div class="field-group">
        <label class="field-label"
          >First Name <span class="required-field-indicator">*</span></label
        >
        <app-text-input
          label="first name"
          placeholder="Enter your first name"
          [control]="getControl('firstName')"
          [isFormSubmitted]="isFormSubmitted"
        ></app-text-input>
      </div>

      <div class="field-group">
        <label class="field-label"
          >Last Name <span class="required-field-indicator">*</span></label
        >
        <app-text-input
          label="last name"
          placeholder="Enter your last name"
          [control]="getControl('lastName')"
          [isFormSubmitted]="isFormSubmitted"
        ></app-text-input>
      </div>

      <!-- <div class="field-group">
        <label class="field-label">Job Title / Role</label>
        <app-text-input
          label="job title / role"
          placeholder="e.g., Creative Director, Marketing Manager"
          [control]="getControl('userRole')"
          [isFormSubmitted]="isFormSubmitted"
        ></app-text-input>
      </div> -->

      <div class="action-buttons">
        <button
          class="btn btn-ghost width-100"
          (click)="skipStep()"
          [disabled]="
            getControl('firstName')?.invalid ||
            getControl('lastName')?.invalid ||
            isLoadingStep
          "
        >
          Skip
        </button>

        <button
          class="btn btn-amber width-100"
          (click)="nextStep()"
          [disabled]="
            getControl('firstName')?.invalid ||
            getControl('lastName')?.invalid ||
            isLoadingStep
          "
        >
          @if (isLoadingStep) {
            <span class="btn-loading">
              <span class="spinner"></span>
              <span>Loading...</span>
            </span>
          } @else {
            Continue
          }
        </button>
      </div>
    </div>

    <!-- Step 2: Company Setup -->
    <div class="step-content" [class.active]="currentStep === 2">
      <div class="step-card-header">
        <div class="step-number">STEP 2 OF 5</div>
        <div class="card-title">Set up your company</div>
        <div class="card-subtitle">Tell us about your organization</div>
      </div>

      <div class="field-group">
        <label class="field-label">Company Logo</label>
        <div
          class="avatar-box"
          role="button"
          tabindex="0"
          (click)="companyLogoInput.click()"
          (keydown.enter)="companyLogoInput.click()"
          (keydown.space)="companyLogoInput.click()"
        >
          @if (!companyLogoPreviewUrl) {
            <span class="avatar-box-text">Select Logo</span>
          } @else {
            <img [src]="companyLogoPreviewUrl" alt="Company logo" />
          }
        </div>
        <input
          #companyLogoInput
          type="file"
          accept="image/png,image/jpeg,image/webp"
          (change)="onCompanyLogoSelected($event)"
          hidden
        />
      </div>

      <div class="field-group">
        <label class="field-label"
          >Company Name <span class="required-field-indicator">*</span></label
        >
        <app-text-input
          label="company name"
          placeholder="Enter company name"
          [control]="getControl('companyName')"
          [isFormSubmitted]="isFormSubmitted"
        ></app-text-input>
      </div>

      <div class="field-group">
        <label for="companyName" class="field-label">Website (optional)</label>
        <app-text-input
          label="website"
          placeholder="Enter your company website"
          [control]="getControl('website')"
          [isFormSubmitted]="isFormSubmitted"
        ></app-text-input>
      </div>

      <div class="field-group d-flex align-items-start flex-column">
        <label class="field-label" for="indutry">Industry</label>
        <app-select-input
          label="industry"
          placeholder="Select your industry"
          [control]="getControl('industry')"
          [items]="industryList"
          [allowClear]="true"
          [dropdownClassName]="'common-dropdown-menu'"
          class="common-dark-dropdown"
        ></app-select-input>
      </div>

      <div class="field-group d-flex align-items-start flex-column">
        <label for="" class="label"
          >Company size
          <img
            nz-tooltip
            nzTooltipTitle="Help us understand your team structure and collaboration
                      needs"
            nzTooltipPlacement="top"
            src="../../../../assets/images/user-grey-icon.svg"
            alt=""
          />
          <span class="required-field-indicator">*</span></label
        >

        <app-select-input
          label="company size"
          placeholder="Select your company size"
          [control]="getControl('companySize')"
          [items]="companySizeList"
          [allowClear]="true"
          [dropdownClassName]="'common-dropdown-menu'"
          class="common-dark-dropdown"
        ></app-select-input>
      </div>

      <div class="field-group d-flex align-items-start flex-column">
        <label class="label"
          >Your role <span class="required-field-indicator">*</span></label
        >
        <app-select-input
          label="role"
          placeholder="Select your role"
          [control]="getControl('role')"
          [items]="roleList"
          [valueKey]="'id'"
          [labelKey]="'role_name'"
          [allowClear]="true"
          [dropdownClassName]="'common-dropdown-menu'"
          class="common-dark-dropdown"
        ></app-select-input>
      </div>

      <div class="action-buttons">
        <button
          class="btn btn-ghost width-100"
          (click)="skipStep()"
          [disabled]="
            getControl('companyName')?.invalid ||
            getControl('companySize')?.invalid ||
            isLoadingStep
          "
        >
          Skip
        </button>
        <button
          class="btn btn-amber width-100"
          (click)="nextStep()"
          [disabled]="
            getControl('companyName')?.invalid ||
            getControl('companySize')?.invalid ||
            isLoadingStep
          "
        >
          @if (isLoadingStep) {
            <span class="btn-loading">
              <span class="spinner"></span>
              <span>Loading...</span>
            </span>
          } @else {
            Continue
          }
        </button>
      </div>
    </div>

    <!-- Step 3: Knowledge Base -->
    <div class="step-content" [class.active]="currentStep === 3">
      <div class="step-card-header">
        <div class="step-number">STEP 3 OF 5</div>
        <div class="card-title">Knowledge Base</div>
        <div class="card-subtitle">
          Add your brand guidelines and context for AI-powered tools
        </div>
      </div>

      <div class="info-box">
        <p>📚 <strong>What is Knowledge Base?</strong></p>
        <p>
          Upload brand guidelines, target audience info, and creative
          references. Our AI tools will use this to generate on-brand content
          automatically.
        </p>
      </div>

      <div class="field-group">
        <label class="field-label">Brand Guidelines (Optional)</label>
        <div
          class="kb-upload"
          [class.drag-over]="isDragOver"
          (click)="onUploadClick('brandGuidelines')"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div class="kb-upload-icon">📄</div>
          <div class="kb-upload-text">Drop files here or click to upload</div>
          <div class="kb-upload-hint">PDF, DOC, DOCX up to 5MB</div>
        </div>
        <input
          id="brandGuidelinesFileInput"
          type="file"
          accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          (change)="onBrandGuidelinesFileSelected($event)"
          multiple
          hidden
        />

        <!-- Uploaded Files List -->
        @if (brandGuidelinesFiles.length > 0) {
          <div class="uploaded-files-list">
            @for (file of brandGuidelinesFiles; track $index; let i = $index) {
              <div class="uploaded-file-item">
                <div class="file-info">
                  <span class="file-icon">📄</span>
                  <div class="file-details">
                    <span class="file-name">{{ file.name }}</span>
                    <span class="file-size">{{
                      formatFileSize(file.size)
                    }}</span>
                  </div>
                </div>
                <button
                  class="remove-file-btn"
                  (click)="removeBrandGuidelinesFile(i)"
                  type="button"
                  aria-label="Remove file"
                >
                  ✕
                </button>
              </div>
            }
          </div>
        }
      </div>

      <div class="field-group d-flex align-items-start flex-column">
        <label class="field-label">Target Audience</label>
        <app-select-input
          label="target audience"
          placeholder="Select target audience"
          [control]="getControl('targetAudience')"
          [items]="targetAudienceList"
          [valueKey]="'id'"
          [labelKey]="'name'"
          [allowClear]="true"
          [dropdownClassName]="'common-dropdown-menu'"
          class="common-dark-dropdown"
          [isFormSubmitted]="isFormSubmitted"
        ></app-select-input>
      </div>

      <div class="action-buttons">
        <button
          class="btn btn-ghost width-100"
          (click)="skipStep()"
          [disabled]="isLoadingStep"
        >
          Skip for now
        </button>
        <button
          class="btn btn-amber width-100"
          (click)="nextStep()"
          [disabled]="isLoadingStep"
        >
          @if (isLoadingStep) {
            <span class="btn-loading">
              <span class="spinner"></span>
              <span>Loading...</span>
            </span>
          } @else {
            Continue
          }
        </button>
      </div>
    </div>

    <!-- Step 4: Invite Team -->
    <div class="step-content" [class.active]="currentStep === 4">
      <div class="step-card-header">
        <div class="step-number">STEP 4 OF 5</div>
        <div class="card-title">Invite your team</div>
        <div class="card-subtitle">
          Collaborate with team members on campaigns and projects
        </div>
      </div>

      <div class="field-group">
        <label class="field-label">Invite Email</label>
        <div class="invite-input-group">
          <app-text-input
            label="invite email"
            placeholder="Enter email address"
            [control]="getControl('inviteEmail')"
            [isFormSubmitted]="isFormSubmitted"
            (keydown.enter)="addInvite()"
          ></app-text-input>
          <button class="btn btn-amber" (click)="addInvite()">+ Add</button>
        </div>
      </div>

      <div class="invited-list">
        @for (email of invitedEmails; track email) {
          <div class="invited-item">
            <span class="invited-email">{{ email }}</span>
            <button class="remove-btn" (click)="removeInvite(email)">✕</button>
          </div>
        }
      </div>

      <div class="info-box">
        <p>💡 <strong>Team members can:</strong></p>
        <p>• Collaborate on campaigns and video projects</p>
        <p>• Use AI creative tools</p>
        <p>• Share feedback and approvals</p>
      </div>

      <div class="action-buttons">
        <button
          class="btn btn-ghost width-100"
          (click)="skipStep()"
          [disabled]="isLoadingStep"
        >
          Skip
        </button>
        <button
          class="btn btn-amber width-100"
          (click)="nextStep()"
          [disabled]="isLoadingStep"
        >
          @if (isLoadingStep) {
            <span class="btn-loading">
              <span class="spinner"></span>
              <span>Loading...</span>
            </span>
          } @else {
            Continue
          }
        </button>
      </div>
    </div>

    <!-- Step 5: Create Campaign -->
    <div class="step-content" [class.active]="currentStep === 5">
      <div class="step-card-header">
        <div class="step-number">STEP 5 OF 5</div>
        <div class="card-title">Create your first campaign</div>
        <div class="card-subtitle">
          Organize your video projects into campaigns
        </div>
      </div>

      <div class="campaign-preview">
        <h4>What you can do with campaigns:</h4>
        <div class="campaign-feature">
          <div class="feature-icon">📁</div>
          <span>Organize multiple video projects</span>
        </div>
        <div class="campaign-feature">
          <div class="feature-icon">🎯</div>
          <span>Set campaign goals and objectives</span>
        </div>
        <div class="campaign-feature">
          <div class="feature-icon">👥</div>
          <span>Collaborate with your team</span>
        </div>
        <div class="campaign-feature">
          <div class="feature-icon">🤖</div>
          <span>Use AI tools: BriefX, ConceptX, ScriptX & more</span>
        </div>
      </div>

      <div class="field-group">
        <label class="field-label">Campaign Name</label>
        <app-text-input
          label="campaign name"
          placeholder="e.g., Q1 Product Launch 2025"
          [control]="getControl('campaignName')"
          [isFormSubmitted]="isFormSubmitted"
          class=""
        ></app-text-input>
      </div>

      <div class="field-group">
        <label class="field-label">Campaign Description</label>
        <app-text-area
          label="campaign description"
          placeholder="Describe the campaign objectives, target audience, and key deliverables..."
          [control]="getControl('campaignDescription')"
          
          [isFormSubmitted]="isFormSubmitted"
          [max]="500"
          rowsCount="4"
        ></app-text-area>
      </div>

      <div class="d-flex gap-2 w-100">
        <div class="field-group">
          <label class="field-label">Start Date</label>
          <app-date-picker
            label="start date"
            placeholder="Select start date"
            [control]="getControl('startDate')"
            [isFormSubmitted]="isFormSubmitted"
            class="form-date-picker-input-v1"
          ></app-date-picker>
        </div>

        <div class="field-group">
          <label class="field-label">End Date</label>
          <app-date-picker
            label="end date"
            placeholder="Select end date"
            [control]="getControl('endDate')"
            [isFormSubmitted]="isFormSubmitted"
            class="form-date-picker-input-v1"
          ></app-date-picker>
        </div>
      </div>

      <div class="action-buttons">
        <button
          class="btn btn-ghost width-100"
          (click)="skipToHome()"
          [disabled]="isLoadingStep"
        >
          Skip & Go to Dashboard
        </button>
        <button
          class="btn btn-amber width-100"
          (click)="createCampaign()"
          [disabled]="isLoadingStep"
        >
          @if (isLoadingStep) {
            <span class="btn-loading">
              <span class="spinner"></span>
              <span>Creating...</span>
            </span>
          } @else {
            Create Campaign
          }
        </button>
      </div>
    </div>
  </div>
</div>
